/**
 *  ModuleSettings entity class
 */

/**
 * ModuleSettingsFactory
 * returns ModuleSettings entity class
 *
 * @class ModuleSettingsFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ModuleSettings} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ModuleSettingsFactory
 */
import { MODULE_LOCALIZATION_PAIRS, metadataMapToLocalizations, localizationsToMetadataMap } from 'app/helpers/localization'

/* @ngInject */
export default function ModuleSettingsFactory (Type, Entity, onOffMixin) {
  /* === ModuleSettings class === */

  /**
   * ModuleSettings model
   *
   * @class ModuleSettings
   * @classdesc ModuleSettings model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.ModuleSettings} ModuleSettings entity
   */
  function ModuleSettings () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ModuleSettings.prototype = Object.create(Entity.prototype)
  ModuleSettings.prototype.constructor = ModuleSettings

  /* === ModuleSettings instance methods & fields === */

  Object.assign(ModuleSettings.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ModuleSettings#
     * @type {Object}
     */
    _fields: {
      id: Number,
      contentType: 'ROWS',
      enabled: false,
      iconName: String,
      identifier: String,
      localizedTitleKey: String,
      moduleType: 'CUSTOM',
      networkId: Number,
      profileTypeTitle: String,
      rows: ['NetworkRow'],
      switchable: Boolean,
      title: String,
      localizationMetadata: {} // map<langCode, {title}>
    },

    /**
     * url template
     *
     * @memberof models.ModuleSettings#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/appearance/modules/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.ModuleSettings#
     * @type {String}
     */
    _publicUrlTemplate: 'organizations/{{::networkId}}/customization/modules/{{::id}}',

    /**
     * Prepare Accessory
     *
     * @memberof models.ModuleSettings#
     * @override
     */
    _prepare: function () {
      this.localizations = metadataMapToLocalizations(this.localizationMetadata, MODULE_LOCALIZATION_PAIRS)
    },
    /**
     * Get underlying object
     *
     * @memberof models.ModuleSettings#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      this.localizationMetadata = localizationsToMetadataMap(this.localizations, MODULE_LOCALIZATION_PAIRS)
      return Entity.prototype._object.apply(this, arguments)
    }

  }, onOffMixin)

  /* === ModuleSettings static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ModuleSettings, Entity)
  ModuleSettings._name = 'ModuleSettings'
  ModuleSettings.init()

  // permissions
  ModuleSettings.access = {
  }

  return ModuleSettings
}
